import { render, staticRenderFns } from "./erpEvent__list.vue?vue&type=template&id=97be8ede"
import script from "./erpEvent__list.vue?vue&type=script&lang=js"
export * from "./erpEvent__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports